export const FGVTheme = {
  palette: {
    primary: {
      main: "#d50910",
      light: "#d50910cd",
      hoverColor: "#f5323b",
    },
    secondary: {
      main: "#e4e5e6",
      light: "#ffffff",
      hoverColor: "#b2b3b4",
    },
    deleteColor: "#FF0000",
    confirmDialog: {
      main: "#f83245",
      light: "#f8324526",
    },
  },
  mixins: {
    toolbar: {
      minHeight: 40,
    },
  },
};

export const SIDEBAR_COLOR = {
  code: FGVTheme.palette.primary.main,
  themeColor: "red",
};
